export default __webpack_public_path__ + "static/media/jubailevent.6711e73b.jpg";